// Bootstrap tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// Validate email address before submitting the form
const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const residentFinderForm = document.getElementById('resident_finder');
const residentFinderFormEmailInput = document.getElementById('email');
const residentBackButtons = ['resident_success_back', 'resident_error_back'];

function toggleFormSubmit(active) {
  const submitButton = residentFinderForm.querySelector('button[type="submit"]');
  const spinner = submitButton.querySelector('.spinner');
  if (active) {
    submitButton.removeAttribute('disabled');
    spinner.classList.toggle("d-none", true);
    residentFinderFormEmailInput.setAttribute('data-1p-ignore', 'false');
  } else {
    submitButton.setAttribute('disabled', 'disabled');
    spinner.classList.toggle("d-none", false);
    residentFinderFormEmailInput.setAttribute('data-1p-ignore', 'true');
  }
}

function setStageForm() {
  const element = document.getElementById('email');
  element.value = "";
}

function setStageSuccess(email) {
  const element = document.getElementById('successEmail');
  element.textContent = email;
}

function togglePanels(showForm, showSuccess, showError) {
  document.getElementById('resident_form').classList.toggle('is-visible', showForm);
  document.getElementById('resident_success').classList.toggle('is-visible', showSuccess);
  document.getElementById('resident_error').classList.toggle('is-visible', showError);
}

residentFinderForm.addEventListener('submit', function(evt) {
  evt.preventDefault();
  const actionUrl = evt.target.action;
  const inputEmail = evt.target.email.value.trim();

  if (validateEmail(inputEmail)) {
    residentFinderFormEmailInput.classList.toggle("is-invalid", false);
  } else {
    residentFinderFormEmailInput.classList.toggle("is-invalid", true);
    return;
  }

  toggleFormSubmit(false);

  fetch(actionUrl, {
    method: 'POST',
    body: JSON.stringify({ email: inputEmail }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then((data) => {
    setStageSuccess(data.email);
    togglePanels(false, true, false);
  })
  .catch((error) => {
    togglePanels(false, false, true);
  })
  .finally(() => {
    toggleFormSubmit(true);
  });
});

residentBackButtons.forEach(backButton => {
  const backElement = document.getElementById(backButton);
  backElement.addEventListener('click', (evt) => {
    evt.preventDefault();
    setStageForm();
    togglePanels(true, false, false);
  });
});
